

















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { performanceServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
})
export default class FeedbackDialog extends Vue {
  private dialogVisible: any = false;
  private title = '';
  private activeName: any = '';

  private feedBackHazardList: any = []; // 待反馈隐患列表
  private hazardRectifyFinish = []; // 已整改隐患
  private hazardRectifyNotFinish = []; // 未整改隐患

  private hazardsArr = [];

  private hazardRectifyFlag: any = true; // 已整改/未整改 标识
  private delayFlag: any = false; // 延期反馈/普通反馈 标识
  private rectifyFormId: any = ''; // 整改单 id

  private serverUrl = publishObjectPath.imgPathWater;
  fileList: any = [];
  headers: any = {};
  actionUrl: any = ''; // 图片上传
  hazardPicIndex: any = 0;

  private submitLoading: any = false;

  @Watch('hazardRectifyFlag')
  private typeChange(newValue: any, oldValue: string) {
    if (newValue) {
      this.hazardsArr = this.hazardRectifyFinish;
    } else {
      this.hazardsArr = this.hazardRectifyNotFinish;
    }
    this.activeName = this.hazardsArr[0] ? (this.hazardsArr[0] as any).id : '';
  }
  private handleClick(tab: any, event: any) {}

  hazardPicUpload(index: any) {
    this.hazardPicIndex = index;
  }
  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    (this.hazardRectifyNotFinish[this.hazardPicIndex] as any).rectifyPicture = arr.toString();
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    (this.hazardRectifyNotFinish[this.hazardPicIndex] as any).rectifyPicture = arr.toString();
  }

  showDialog(data: any) {
    this.rectifyFormId = data.rectifyFormId;
    this.delayFlag = data.delayFlag;
    this.title = data.delayFlag ? '延期反馈' : '普通反馈';
    this.feedBackHazardList = data.feedBackHazardList;
    this.hazardRectifyFinish = this.feedBackHazardList.filter((item: any) => item.status === 'RECTIFIED');
    this.hazardRectifyNotFinish = this.feedBackHazardList.filter((item: any) => item.status !== 'RECTIFIED');
    this.hazardsArr = this.hazardRectifyFinish;
    this.activeName = this.hazardsArr[0] ? (this.hazardsArr[0] as any).id : '';
    this.dialogVisible = true;
  }

  submitOrgan() {
    const rectifiedHazard: any = this.hazardRectifyFinish.map((item: any) => {
      return {
        hazardId: item.id,
        feedbackRemark: item.feedbackRemark,
        feedbackContent: item.feedbackContent,
      };
    });
    const rectifyFailHazard: any = this.hazardRectifyNotFinish.map((item: any) => {
      return {
        hazardId: item.id,
        feedbackRemark: item.feedbackRemark,
        feedbackContent: item.feedbackContent,
        forceRectifyHazard: {
          hazardId: item.id,
          rectifyContent: item.rectifyContent,
          rectifyPicture: item.rectifyPicture,
        },
      };
    });

    const formData: any = {
      rectifyFormId: this.rectifyFormId,
      feedbackHazards: rectifiedHazard.concat(rectifyFailHazard),
      delayFlag: this.delayFlag,
    };
    this.submitLoading = true;
    performanceServer
      .feedbackHazard(formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.submitLoading = false;
          this.closeDialog();
        } else {
          this.$message.warning(res.msg);
          this.submitLoading = false;
        }
      })
      .catch(() => {});
  }
  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.serverUrl}${item.path}`);
    });
    return arr;
  }

  closeDialog() {
    this.dialogVisible = false;
    this.hazardRectifyFlag = true;
    this.$emit('feedBackRes');
  }
  mounted() {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
  }
}
